import { render, staticRenderFns } from "./DSBackground.vue?vue&type=template&id=dfa12594&"
import script from "./DSBackground.vue?vue&type=script&lang=js&"
export * from "./DSBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports